import { FTMarketIds } from "../../typings";
export var isMarketType = function (marketTypeId, marketType) {
    return FTMarketIds[marketType].indexOf(marketTypeId) > -1;
};
//# sourceMappingURL=isMarketType.js.map